<template>
  <div>
    <div class="title">
      <span>绑定微信</span>
    </div>
    <div
      class="iframe-title"
      style="text-align: center; background-color: white;"
    >
      <span>微信扫一扫</span>
    </div>
    <div id="qrcode"></div>
    <div class="skip">
      <a @click="handleSkip">跳过</a>
    </div>
  </div>
</template>

<script>
import axios from "@/global/request/axios";
import API from "@/global/request/api";
import { getQuery } from "@/utils/tool";

export default {
  data() {
    return {};
  },
  mounted() {
    axios
      .get(API.wechatInfo, {
        params: { scene: "bind" }
      })
      .then(res => {
        new window.WxLogin({
          id: "qrcode",
          appid: res.appid,
          scope: "snsapi_login",
          redirect_uri: res.redirect_uri,
          state: res.state,
          href: res.href
        });
      })
      .catch(() => {});
  },
  methods: {
    handleSkip() {
      const referer = getQuery("referer");
      window.location.href = referer;
    }
  }
};
</script>

<style lang="less" scoped>
#qrcode {
  text-align: center;
  width: 600px;
  height: 320px;
  margin: 0 auto;
  background-color: white;
  overflow: hidden;
}

#qrcode iframe {
  height: 320px;
}

.title {
  text-align: center;
  margin: 20px auto;
}

.title span {
  font-size: 200%;
}

.iframe-title {
  text-align: center;
  background-color: white;
  width: 600px;
  margin: auto;
  margin-bottom: -20px;
  padding: 20px;
  box-sizing: border-box;
}

.skip {
  text-align: center;
  margin: 20px auto;
}

.skip a {
  cursor: pointer;
}
</style>
